var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBD00",
    d: "M6.687 12c0-.992.273-1.92.748-2.715v-3.37H4.063A9.924 9.924 0 0 0 2 11.998c0 2.23.725 4.348 2.063 6.086h3.372v-3.372A5.28 5.28 0 0 1 6.687 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F9D58",
    d: "m12 17.313-2.344 2.344L12 22c2.23 0 4.347-.725 6.085-2.063V16.57h-3.368a5.312 5.312 0 0 1-2.717.744Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#31AA52",
    d: "m7.435 14.713-3.372 3.371c.265.344.554.674.866.986A9.935 9.935 0 0 0 12 21.999V17.31a5.315 5.315 0 0 1-4.565-2.598Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C79E6",
    d: "M22 12c0-.608-.055-1.218-.164-1.812l-.088-.48H12v4.688h4.744a5.289 5.289 0 0 1-2.027 2.173l3.368 3.368c.344-.265.674-.554.986-.866A9.935 9.935 0 0 0 22 12Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CF2D48",
    d: "m15.756 8.243.415.415 3.314-3.315-.414-.414A9.934 9.934 0 0 0 12 2L9.656 4.344 12 6.687c1.419 0 2.753.553 3.756 1.556Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB4132",
    d: "M12 6.687V2A9.935 9.935 0 0 0 4.93 4.929c-.312.312-.6.642-.866.986l3.372 3.371A5.315 5.315 0 0 1 12 6.687Z"
  })));
};
export default SvgGoogle;